import { render, staticRenderFns } from "./prncatg_bak.vue?vue&type=template&id=0e5d8e6f&scoped=true"
import script from "./prncatg_bak.vue?vue&type=script&lang=js"
export * from "./prncatg_bak.vue?vue&type=script&lang=js"
import style0 from "./prncatg_bak.vue?vue&type=style&index=0&id=0e5d8e6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5d8e6f",
  null
  
)

export default component.exports